import useTheme from "./useTheme";
import { mergeProps } from "solid-js";
export default function useThemeProps(options) {
    const props = [];
    const propDefaults = typeof options.propDefaults === "function"
        ? options.propDefaults({
            set: (v) => v,
            inProps: options.props,
        })
        : options.propDefaults;
    const theme = useTheme();
    const themeProps = theme.components?.[options.name]?.defaultProps;
    if (propDefaults)
        props.push(propDefaults);
    if (themeProps)
        props.push(themeProps);
    if (!props.length)
        return options.props;
    return mergeProps(...[...props, options.props]);
}
